import React from "react";
import { useTranslation } from "react-i18next";
import ReactPaginate from "react-paginate";

interface PaginationProps {
  currentPage: number;
  pageSize: number;
  totalItems: number;
  onChangePage: (page: number) => void;
}

const Pagination: React.FC<PaginationProps> = ({
  currentPage,
  pageSize,
  totalItems,
  onChangePage,
}) => {
  const { t } = useTranslation();

  const calculateStartIndex = () => {
    if (!totalItems) return 0;
    return Math.max(0, currentPage * pageSize + 1);
  };

  const calculateEndIndex = () => {
    const expectedEndIndex = (currentPage + 1) * pageSize;
    return Math.min(totalItems, expectedEndIndex);
  };

  const calculatePageCount = () => {
    const pageCount = Math.ceil(totalItems / pageSize);
    return Math.max(pageCount, 1);
  };

  return (
    <div className="space-y-2 lg:flex lg:items-center lg:justify-between lg:space-y-0">
      <p>
        {t("_published_picture._showing_result", {
          total: totalItems,
          start: calculateStartIndex(),
          end: calculateEndIndex(),
        })}
      </p>
      <ReactPaginate
        pageCount={calculatePageCount()}
        pageRangeDisplayed={1}
        breakLabel="..."
        previousLabel={`< ${t("_published_picture._back_page")}`}
        previousClassName="font-regular text-[12px]"
        previousLinkClassName="block rounded border border-primary bg-white px-3 py-2 text-primary transition-colors duration-200 ease-out hover:bg-primary/10"
        nextLabel={`${t("_published_picture._next_page")} >`}
        nextClassName="font-regular text-[12px]"
        nextLinkClassName="block rounded border border-primary bg-white px-3 py-2 text-primary transition-colors duration-200 ease-out hover:bg-primary/10"
        containerClassName="flex items-center space-x-1"
        pageClassName="font-regular text-[12px]"
        pageLinkClassName="block rounded border border-primary bg-white px-3 py-2 text-primary transition-colors duration-200 ease-out hover:underline"
        activeLinkClassName="!border-primary !bg-primary !text-white hover:!no-underline"
        breakClassName="font-regular text-[12px] text-[#767676]"
        breakLinkClassName="block px-2 py-2"
        onPageChange={(e: { selected: number }) => onChangePage(e.selected)}
        forcePage={currentPage}
      />
    </div>
  );
};

export default Pagination;
